<template>
  <div class="govaffairs">
    <div class="auto_1280">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="( item, index ) in List" :key="index">
            <a :href="item.content" target="_blank" ref="nofollow">
              <div class="pic bg_cover" :style="'background-image: url(' + item.coverImg + ')'"></div>
            </a>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.css'
export default {
  name: 'GovAffairs',
  data () {
    return {
      List: [],
      articleTypeId: 31
    }
  },
  mounted () {
    const self = this
    self.initId()
    self.$api.post('api/benefitArticle/queryByParam', { articleTypeId: this.articleTypeId, current: 1, pageSize: 50 }, r => {
      if (r.data) {
        r.data.forEach((item) => {
          self.List.push(item)
        })
      }
      this.$nextTick(function () {
        this.init()
      })
    })
  },
  activated () {
    this.initId()
  },
  methods: {
    initId () {
      const self = this
      // let menuList
      // try {
      //   menuList = JSON.parse(localStorage.getItem('routeList'))
      // } catch (e) {
      //   console.log(e)
      // }
      // const id = parseInt(self.$route.query.columnId)
      // const index = self.$route.path.lastIndexOf('/')
      // const path = self.$route.path.substring(index + 1, self.$route.path.length)
      // menuList.forEach((item) => {
      //   if (id === item.id) {
      //     item.children.forEach((inner) => {
      //       if (inner.requestTo.toLowerCase() === path) {
      //         this.articleTypeId = inner.id
      //         this.$store.commit('changeId', inner.id)
      //       }
      //     })
      //   }
      // })
      self.$store.commit('changeId', self.articleTypeId)
    },
    init () {
      /* eslint-disable no-new */
      new Swiper('.swiper-container', {
        pagination: '.swiper-pagination',
        slidesPerView: 5,
        slidesPerColumn: 2,
        slidesPerGroup: 5,
        spaceBetween: 40,
        paginationClickable: true,
        loop: false,
        autoplay: false,
        speed: 1000,
        breakpoints: {
          768: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 30,
          }
        }
      })
    }
  }
}
</script>
<style>
.govaffairs{padding: 2% 0 5%; position: relative;}
.govaffairs .auto_1280{overflow: hidden;}
.govaffairs li{width: 20%; float: left; border: 1px solid #fff5f5; transition: all .3s;}
.govaffairs .pic{width: 100%; padding-top: 68%; transition: all .3s; background-size: contain;}
.govaffairs .swiper-container{padding: 3% 1%;}
.govaffairs .swiper-slide{transition: all .3s;}
.govaffairs .swiper-slide:hover .pic{filter: initial; -webkit-filter: initial;}
.govaffairs .swiper-slide:hover{box-shadow: 0px 0px 15px 5px rgba(0, 0, 0, 0.1); z-index: 10; position: relative;}
.govaffairs .swiper-pagination{width: 100%; bottom: 0!important;}
.govaffairs .swiper-pagination span{margin: auto 8px!important;background: #e4007d9a!important;}
.govaffairs .swiper-pagination .swiper-pagination-bullet-active{background: #e4007f!important;}
@media(max-width: 768px){
  .govaffairs .swiper-container{padding-bottom: 7%;}
  /* .govaffairs .swiper-pagination{bottom: -3%!important;} */
}
</style>
